import React from 'react';
import browserUpdate from 'browser-update';

const impossibleVersion = 999;

const options = {
    required: {
        e: 12, // Edge versions 12 and greater
        i: 11, // Internet Explorer 11 only
        f: -7, // Firefox latest or 7 versions behind
        s: -1, // Safari latest or 1 version behind
        c: -8, // Chrome latest or 8 versions behind
        ios: -2, // iOS Browser latest or 2 versions behind
        samsung: -2, // Samsung Internet (Android) borwser latest or 2 versions behind
        o: impossibleVersion, // No Opera support
        o_a: impossibleVersion, // No Opera Mobile support
        y: impossibleVersion, // No Yandex Browser support
        v: impossibleVersion, // No Vivaldi support
        uc: impossibleVersion // No UC Browser support
    },
    insecure: false,
    url: '/unsupported-browser',
    reminder: 0, // Always show
    text: "Your current web browser ({brow_name}) is not supported by Recreation.gov. Update your browser for better security, speed, and the best experience on the site. You will not be able to purchase anything until you have upgraded your browser or use an alternative compatible browser.<br /> <a {up_but} class=\"rec-button-primary\" rel=\"noopener noreferrer\">Upgrade Browser</a> <a {ignore_but} class=\"rec-button-tertiary\" rel=\"noopener noreferrer\">Ignore</a>"
}

export default class IncompatibleBrowserNotice extends React.Component {
    render() {
        return (
            <div className="rec-incompatiable-browser-notice">
                {browserUpdate(options)}
            </div>
        );
    }
}
